import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import LocalAirportIcon from "@mui/icons-material/LocalAirport";
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import { yellow } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import { useEffect } from "react";
import { getAirports } from "../actions/airport";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

export default function SimpleDialog(props) {

    const { onClose, selectedValue, open } = props;

    let airportsLoaded = false;
    const dispatch = useDispatch();
    const { airports: listAirports } = useSelector((state) => state.airports);

    useEffect(() => {
        if (!airportsLoaded) {
            dispatch(getAirports()).then(() => {
                airportsLoaded = true;
            });
        }
    }, []);

    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>Please select an airport</DialogTitle>
            <List sx={{ pt: 0 }}>
                {listAirports && listAirports.filter((airport) => airport.active).map((airport) => (
                    <ListItem button onClick={() => handleListItemClick(airport)} key={airport.id}>
                        <ListItemAvatar>
                            <Avatar sx={{ bgcolor: yellow[100], color: yellow[600] }}>
                                <LocalAirportIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={airport.name} />
                    </ListItem>
                ))}
            </List>
        </Dialog>
    );
}

SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};

